import { URLS, UrlsEntry } from '@/urlsConfig';
import HEADER from '@/azure/page/header';
import FOOTER from '@/azure/page/footer';

const LOGIN_FORM_CLASS = '.form__outer-container';
const LOGIN_INNER_FORM_CLASS = '.form__inner-container';

const addHeader = (): void => {
  document.querySelector(LOGIN_FORM_CLASS)?.insertAdjacentHTML('beforebegin', HEADER);
};

const addFooter = (): void => {
  document.querySelector(LOGIN_FORM_CLASS)?.insertAdjacentHTML('afterend', FOOTER);
};

const styleLoginModal = (): void => {
  (document.querySelector(LOGIN_FORM_CLASS) as HTMLElement).style.minHeight = 'auto';
  (document.querySelector(LOGIN_INNER_FORM_CLASS) as HTMLElement).style.paddingTop = '64px';
};

export const styleRedirectPage = (): void => {
  addHeader();
  styleLoginModal();
  addFooter();
};

export const addCookieBanner = (): void => {
  const envURLS: UrlsEntry[] = Object.values(URLS).filter(
    (envUrls: UrlsEntry) => envUrls.AZURE.BASE_URL === window.location.origin
  );
  if (envURLS && envURLS[0]) {
    const cookieBannerScript = document.createElement('script');
    cookieBannerScript.src = `${envURLS[0].GLOBAL_FRONTEND_SCRIPTS}/cookieBanner.js`;
    cookieBannerScript.setAttribute('data-global-script', 'cookieBanner');
    document.head.appendChild(cookieBannerScript);
  }
};
